(() => {
  const rootSelector = '[data-lcs-g03b-video]';
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let observer;
  let returnFocus;
  let dialogEventsBound = false;

  function setSources(video, enabled) {
    let changed = false;
    video.querySelectorAll('source').forEach((source) => {
      if (enabled && !source.src && source.dataset.src) {
        source.src = source.dataset.src;
        changed = true;
      }
      if (!enabled && source.getAttribute('src')) {
        source.removeAttribute('src');
        changed = true;
      }
    });
    if (changed) video.load();
  }

  function safePlay(video) {
    video.muted = true;
    const playback = video.play();
    if (playback && typeof playback.catch === 'function') playback.catch(() => {});
  }

  function playDialogMedia(dialog) {
    dialog.querySelectorAll('video').forEach((video) => {
      try { video.currentTime = 0; } catch (_error) {}
      const playback = video.play();
      if (playback && typeof playback.catch === 'function') playback.catch(() => {});
    });
    dialog.querySelectorAll('iframe[data-lcs-iframe-src]').forEach((frame) => {
      if (!frame.getAttribute('src')) frame.src = frame.dataset.lcsIframeSrc;
    });
  }

  function stopDialogMedia(dialog) {
    dialog.querySelectorAll('video').forEach((video) => {
      video.pause();
      try { video.currentTime = 0; } catch (_error) {}
    });
    dialog.querySelectorAll('iframe[data-lcs-iframe-src]').forEach((frame) => frame.removeAttribute('src'));
  }

  function revealCollectionImages() {
    const collection = document.getElementById('CollectionSection');
    if (!collection) return;
    collection.querySelectorAll('[data-aos]').forEach((element) => element.classList.add('aos-animate'));
    window.dispatchEvent(new Event('scroll'));
  }

  function scheduleCollectionReveal() {
    requestAnimationFrame(() => requestAnimationFrame(revealCollectionImages));
    window.setTimeout(revealCollectionImages, 180);
    window.setTimeout(revealCollectionImages, 650);
  }

  function syncHeroVideos() {
    const isMobile = mobileQuery.matches;
    const reduceMotion = motionQuery.matches;
    document.querySelectorAll(`${rootSelector}[data-lcs-g03b-video^="hero-"]`).forEach((video) => {
      const shouldLoad = !reduceMotion && ((isMobile && video.dataset.lcsG03bVideo === 'hero-mobile') || (!isMobile && video.dataset.lcsG03bVideo === 'hero-desktop'));
      if (!shouldLoad) video.pause();
      setSources(video, shouldLoad);
      if (shouldLoad) safePlay(video);
    });
  }

  function syncDeferredVideos() {
    if (observer) observer.disconnect();
    const videos = document.querySelectorAll(`${rootSelector}[data-lcs-g03b-video="interview"]`);
    if (!videos.length) return;
    if (motionQuery.matches) {
      videos.forEach((video) => { video.pause(); setSources(video, false); });
      return;
    }
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) { setSources(video, true); safePlay(video); } else { video.pause(); }
      });
    }, { rootMargin: '240px 0px', threshold: 0.01 });
    videos.forEach((video) => observer.observe(video));
  }

  function closeDialog(dialog) {
    stopDialogMedia(dialog);
    dialog.close();
    returnFocus?.focus();
  }

  function initializeProductCards() {
    document.querySelectorAll('[data-lcs-product-card]').forEach((card) => {
      if (card.dataset.lcsProductCardReady) return;
      const source = card.querySelector('[data-lcs-product-variants]');
      const swatchHost = card.querySelector('[data-lcs-product-swatches]');
      const media = card.querySelector('.lcs-g04a-product-mini__media');
      const primary = card.querySelector('[data-lcs-primary-image]');
      const link = card.querySelector('[data-lcs-product-link]');
      const colorLabel = card.querySelector('[data-lcs-color-label]');
      if (!source || !swatchHost || !media || !primary || !link) return;

      let variants;
      try { variants = JSON.parse(source.textContent); } catch (_error) { return; }
      if (!Array.isArray(variants) || !variants.length) return;

      const productName = card.dataset.productName || '商品';
      const selectedColor = card.dataset.selectedColor;
      function ensureSecondary() {
        let secondary = card.querySelector('[data-lcs-secondary-image]');
        if (secondary) return secondary;
        secondary = document.createElement('img');
        secondary.className = 'lcs-g04a-product-mini__image lcs-g04a-product-mini__image--secondary';
        secondary.loading = 'lazy';
        secondary.width = 900;
        secondary.height = 1350;
        secondary.setAttribute('data-lcs-secondary-image', '');
        media.appendChild(secondary);
        return secondary;
      }

      const setMiniSource = (image, source) => {
        try {
          const url = new URL(source, location.href);
          if (url.hostname === 'cdn.shopify.com') {
            url.searchParams.set('width', '240');
            const small = url.href;
            url.searchParams.set('width', '480');
            image.srcset = small + ' 240w, ' + url.href + ' 480w';
            image.sizes = '(max-width: 749px) 30vw, 12vw';
            image.src = url.href;
            return;
          }
        } catch (_) { /* Retain the approved non-URL fallback. */ }
        image.removeAttribute('srcset');
        image.src = source;
      };
      variants.forEach((variant) => {
        const swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'lcs-g04a-product-mini__swatch';
        swatch.style.setProperty('--lcs-swatch', variant.hex || '#ddd');
        swatch.setAttribute('aria-label', `${productName}／${variant.label}`);
        swatch.setAttribute('title', variant.label);
        swatch.setAttribute('aria-pressed', String(variant.label === selectedColor));
        swatch.addEventListener('click', () => {
          setMiniSource(primary, variant.primary);
          primary.alt = `${productName}／${variant.label}／${document.documentElement.lang.startsWith('en') ? 'Main view' : '主圖'}`;
          const secondary = ensureSecondary();
          setMiniSource(secondary, variant.secondary || variant.primary);
          secondary.alt = variant.secondary ? `${productName}／${variant.label}／${document.documentElement.lang.startsWith('en') ? 'Second view' : '第二視角'}` : `${productName}／${variant.label}／${document.documentElement.lang.startsWith('en') ? 'Main view' : '主圖'}`;
          link.href = variant.url;
          if (colorLabel) colorLabel.textContent = variant.label;
          card.classList.toggle('has-secondary', Boolean(variant.secondary && variant.secondary !== variant.primary));
          swatchHost.querySelectorAll('button').forEach((button) => button.setAttribute('aria-pressed', String(button === swatch)));
        });
        swatchHost.appendChild(swatch);
      });

      const selected = variants.find((variant) => variant.label === selectedColor) || variants[0];
      card.classList.toggle('has-secondary', Boolean(selected.secondary && selected.secondary !== selected.primary));
      card.dataset.lcsProductCardReady = 'true';
    });
  }

  function initializeJournalCarousels() {
    document.querySelectorAll('[data-lcs-journal-carousel]').forEach((carousel) => {
      if (carousel.dataset.lcsJournalReady) {
        carousel.lcsJournalRefresh?.();
        return;
      }

      const track = carousel.querySelector('[data-lcs-carousel-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-lcs-carousel-slide]'));
      const progress = carousel.querySelector('[data-lcs-carousel-progress]');
      const toggle = carousel.querySelector('[data-lcs-carousel-toggle]');
      const toggleLabel = carousel.querySelector('[data-lcs-carousel-toggle-label]');
      const duration = Math.max(3000, Math.min(4000, Number(carousel.dataset.lcsCarouselInterval) || 3600));
      if (!track || !slides.length || !progress) return;

      let index = 0;
      let timer;
      let scrollTimer;
      let isVisible = false;
      let isInteracting = false;
      let manualPaused = false;

      function stop() {
        window.clearTimeout(timer);
        timer = undefined;
        carousel.classList.remove('is-lcs-carousel-running');
      }

      function canRun() {
        return mobileQuery.matches && !motionQuery.matches && !manualPaused && !isInteracting && isVisible && !document.hidden && slides.length > 1;
      }

      function restartProgress() {
        carousel.classList.remove('is-lcs-carousel-running');
        progress.style.setProperty('--lcs-carousel-duration', `${duration}ms`);
        void progress.offsetWidth;
        if (canRun()) carousel.classList.add('is-lcs-carousel-running');
      }

      function updateAccessibility() {
        slides.forEach((slide, slideIndex) => {
          const isCurrent = slideIndex === index;
          slide.toggleAttribute('data-lcs-carousel-active', isCurrent);
          slide.setAttribute('aria-hidden', String(!isCurrent && mobileQuery.matches));
          slide.querySelectorAll('a, button').forEach((control) => {
            if (!mobileQuery.matches) control.removeAttribute('tabindex');
            else if (isCurrent) control.removeAttribute('tabindex');
            else control.setAttribute('tabindex', '-1');
          });
        });
      }

      function start() {
        stop();
        updateAccessibility();
        restartProgress();
        if (!canRun()) return;
        timer = window.setTimeout(() => setIndex(index + 1), duration);
      }

      function setIndex(nextIndex, shouldScroll = true) {
        index = (nextIndex + slides.length) % slides.length;
        updateAccessibility();
        if (shouldScroll && mobileQuery.matches) {
          track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: motionQuery.matches ? 'auto' : 'smooth' });
        }
        start();
      }

      function setInteraction(active) {
        isInteracting = active;
        if (active) stop(); else start();
      }

      track.addEventListener('scroll', () => {
        if (!mobileQuery.matches) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const closest = slides.reduce((best, slide, slideIndex) => {
            const distance = Math.abs((slide.offsetLeft - track.offsetLeft) - track.scrollLeft);
            return distance < best.distance ? { distance, slideIndex } : best;
          }, { distance: Infinity, slideIndex: index });
          if (closest.slideIndex !== index) index = closest.slideIndex;
          updateAccessibility();
          start();
        }, 100);
      }, { passive: true });
      track.addEventListener('pointerdown', () => setInteraction(true), { passive: true });
      track.addEventListener('pointerup', () => setInteraction(false), { passive: true });
      track.addEventListener('pointercancel', () => setInteraction(false), { passive: true });
      carousel.addEventListener('focusin', () => setInteraction(true));
      carousel.addEventListener('focusout', () => window.setTimeout(() => {
        if (!carousel.contains(document.activeElement)) setInteraction(false);
      }, 0));

      toggle?.addEventListener('click', () => {
        manualPaused = !manualPaused;
        toggle.setAttribute('aria-pressed', String(manualPaused));
        if (toggleLabel) toggleLabel.textContent = manualPaused ? '播放' : '暫停';
        start();
      });

      const visibilityObserver = new IntersectionObserver((entries) => {
        isVisible = entries.some((entry) => entry.isIntersecting);
        start();
      }, { threshold: 0.25 });
      visibilityObserver.observe(carousel);

      carousel.lcsJournalRefresh = () => {
        if (!mobileQuery.matches) {
          index = 0;
          track.scrollTo({ left: 0, behavior: 'auto' });
        }
        start();
      };
      carousel.dataset.lcsJournalReady = 'true';
      updateAccessibility();
      start();
    });
  }

  function initializeQuickShopSticky() {
    document.querySelectorAll('[data-lcs-quick-shop]').forEach((quickShop) => {
      if (quickShop.dataset.lcsQuickShopReady) {
        quickShop.lcsQuickShopRefresh?.();
        return;
      }
      const sticky = quickShop.querySelector('[data-lcs-sticky-offer]');
      const hero = document.querySelector('.lcs-g04a-hero, .lcs-g03b-hero');
      if (!sticky || !hero) return;

      function sync() {
        const heroRect = hero.getBoundingClientRect();
        const quickRect = quickShop.getBoundingClientRect();
        const quickVisible = quickRect.top < window.innerHeight && quickRect.bottom > 0;
        const shouldShow = mobileQuery.matches && heroRect.bottom <= 0 && !quickVisible;
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', String(!shouldShow));
      }

      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      quickShop.lcsQuickShopRefresh = sync;
      quickShop.dataset.lcsQuickShopReady = 'true';
      sync();
    });
  }

  function initializeLookbooks() {
    document.querySelectorAll('[data-lcs-lookbook]').forEach((lookbook) => {
      if (lookbook.dataset.lcsLookbookReady) {
        lookbook.lcsLookbookRefresh?.();
        return;
      }
      const tabs = Array.from(lookbook.querySelectorAll('[data-lcs-lookbook-tab]'));
      const panels = Array.from(lookbook.querySelectorAll('[data-lcs-lookbook-panel]'));
      const stage = lookbook.querySelector('[data-lcs-lookbook-stage]');
      const previous = lookbook.querySelector('[data-lcs-lookbook-prev]');
      const next = lookbook.querySelector('[data-lcs-lookbook-next]');
      const current = lookbook.querySelector('[data-lcs-lookbook-current]');
      const progress = lookbook.querySelector('[data-lcs-lookbook-progress]');
      const galleryItems = Array.from(lookbook.querySelectorAll('[data-lcs-gallery-item]'));
      const galleryDialog = document.getElementById(lookbook.dataset.lcsGalleryDialogId);
      if (!tabs.length || tabs.length !== panels.length || !stage) return;

      const autoplayDuration = 10000;
      let index = 0;
      let galleryIndex = 0;
      let autoplayTimer;
      let isVisible = false;
      let pointerStartX;
      let pointerStartedOnControl = false;

      function unloadVideo(video) {
        video.pause();
        video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        video.load();
      }

      function loadVideo(video) {
        let changed = false;
        video.querySelectorAll('source').forEach((source) => {
          if (!source.src && source.dataset.src) {
            source.src = source.dataset.src;
            changed = true;
          }
        });
        if (changed) video.load();
        if (motionQuery.matches) video.pause();
        else safePlay(video);
      }

      function stopAutoplay() {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = undefined;
        if (progress) progress.style.animation = 'none';
      }

      function scheduleAutoplay() {
        stopAutoplay();
        if (motionQuery.matches || !isVisible || document.hidden || galleryDialog?.open) {
          if (progress && motionQuery.matches) progress.style.transform = 'scaleX(1)';
          return;
        }
        if (progress) {
          progress.style.transform = 'scaleX(0)';
          void progress.offsetWidth;
          progress.style.animation = `lcs-g05-lookbook-progress ${autoplayDuration}ms linear forwards`;
        }
        autoplayTimer = window.setTimeout(() => setIndex(index + 1), autoplayDuration);
      }

      function setIndex(nextIndex, focusTab = false) {
        index = (nextIndex + panels.length) % panels.length;
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
          panel.querySelectorAll('[data-lcs-lookbook-video]').forEach((video) => active && isVisible ? loadVideo(video) : unloadVideo(video));
        });
        if (current) current.textContent = String(index + 1).padStart(2, '0');
        scheduleAutoplay();
      }

      function setGalleryIndex(nextIndex) {
        if (!galleryDialog || !galleryItems.length) return;
        galleryIndex = (nextIndex + galleryItems.length) % galleryItems.length;
        const item = galleryItems[galleryIndex];
        const image = galleryDialog.querySelector('[data-lcs-gallery-image]');
        const caption = item.dataset.caption || `Gallery ${galleryIndex + 1}`;
        if (image) {
          image.src = item.dataset.src;
          image.alt = item.getAttribute('aria-label')?.replace(/^放大/, '').trim() || caption;
        }
        galleryDialog.querySelectorAll('[data-lcs-gallery-caption]').forEach((node) => { node.textContent = caption; });
      }

      tabs.forEach((tab, tabIndex) => {
        tab.addEventListener('click', () => setIndex(tabIndex));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          setIndex(index + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
      });
      previous?.addEventListener('click', () => setIndex(index - 1));
      next?.addEventListener('click', () => setIndex(index + 1));

      galleryItems.forEach((item, itemIndex) => {
        item.addEventListener('click', () => {
          if (!galleryDialog) return;
          galleryIndex = itemIndex;
          setGalleryIndex(galleryIndex);
          returnFocus = item;
          stopAutoplay();
          galleryDialog.showModal();
        });
      });
      galleryDialog?.querySelector('[data-lcs-gallery-prev]')?.addEventListener('click', () => setGalleryIndex(galleryIndex - 1));
      galleryDialog?.querySelector('[data-lcs-gallery-next]')?.addEventListener('click', () => setGalleryIndex(galleryIndex + 1));
      galleryDialog?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        setGalleryIndex(galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
      galleryDialog?.addEventListener('close', scheduleAutoplay);

      stage.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
        pointerStartedOnControl = Boolean(event.target.closest('a, button, video'));
      }, { passive: true });
      stage.addEventListener('pointerup', (event) => {
        if (pointerStartedOnControl || pointerStartX === undefined) return;
        const distance = event.clientX - pointerStartX;
        if (Math.abs(distance) >= 48) setIndex(index + (distance < 0 ? 1 : -1));
        pointerStartX = undefined;
      }, { passive: true });

      const visibilityObserver = new IntersectionObserver((entries) => {
        isVisible = entries.some((entry) => entry.isIntersecting);
        panels[index].querySelectorAll('[data-lcs-lookbook-video]').forEach((video) => isVisible ? loadVideo(video) : video.pause());
        if (isVisible) scheduleAutoplay(); else stopAutoplay();
      }, { rootMargin: '120px 0px', threshold: 0.18 });
      visibilityObserver.observe(lookbook);

      lookbook.lcsLookbookRefresh = () => setIndex(index);
      lookbook.dataset.lcsLookbookReady = 'true';
      setIndex(0);
    });
  }

  function initializeInterviewSections() {
    document.querySelectorAll('[data-lcs-interview]').forEach((section) => {
      if (section.dataset.lcsInterviewReady) return;
      const video = section.querySelector('[data-lcs-interview-video]');
      if (!video) return;

      const sync = (isVisible = true) => {
        if (motionQuery.matches || !isVisible || document.hidden) video.pause();
        else safePlay(video);
      };
      const observer = new IntersectionObserver((entries) => {
        sync(entries.some((entry) => entry.isIntersecting));
      }, { rootMargin: '120px 0px', threshold: 0.12 });

      observer.observe(section);
      section.dataset.lcsInterviewReady = 'true';
      sync();
    });
  }

  function initializeGenderGateways() {
    const english = document.documentElement.lang.toLowerCase().startsWith('en');
    const localeRoot = window.Shopify?.routes?.root || '/';
    const routes = [
      {
        label: 'Shop Men',
        meta: 'TRANZEND GOLF / MEN',
        href: '/collections/golf/men#CollectionSection',
        image: 'https://cdn.shopify.com/s/files/1/0290/1321/3272/files/Golf_SS26_Button_Polo_Black_Men_Vertical_2e8e1e06-a099-4ba3-9ee9-84ceeefdce3d.png',
        alt: 'TRANZEND GOLF menswear'
      },
      {
        label: 'Shop Women',
        meta: 'TRANZEND GOLF / WOMEN',
        href: '/collections/golf/women#CollectionSection',
        image: 'https://cdn.shopify.com/s/files/1/0290/1321/3272/files/Golf_SS26_Vertical_Hero_4.png',
        alt: 'TRANZEND GOLF womenswear'
      }
    ];

    document.querySelectorAll('.lcs-g04a-looks .lcs-g04a-compact-head').forEach((header) => {
      if (header.dataset.lcsGenderGatewayReady) return;
      const nav = document.createElement('nav');
      nav.className = 'lcs-g11-gender-gateway';
      nav.setAttribute('translate', 'no');
      nav.setAttribute('aria-label', english ? 'Shop TRANZEND GOLF by gender' : '依男女系列瀏覽 TRANZEND GOLF');

      routes.forEach((route) => {
        const link = document.createElement('a');
        link.className = 'lcs-g11-gender-card';
        link.href = localeRoot.replace(/\/$/, '') + route.href;
        link.setAttribute('aria-label', english ? route.label + ' — TRANZEND GOLF' : `${route.label}，前往 TRANZEND GOLF ${route.label === 'Shop Men' ? '男裝' : '女裝'}系列`);
        link.innerHTML = `<img src="${route.image}" alt="${route.alt}" width="1200" height="1600" loading="lazy"><span><small>${route.meta}</small><strong>${route.label}</strong><i aria-hidden="true">→</i></span>`;
        nav.appendChild(link);
      });

      header.replaceChildren(nav);
      header.classList.add('is-lcs-gender-gateway');
      header.dataset.lcsGenderGatewayReady = 'true';
    });
  }

  function initializeEditorialGalleries() {
    document.querySelectorAll('[data-lcs-editorial-gallery]').forEach((gallery) => {
      if (gallery.dataset.lcsEditorialReady) return;
      const items = Array.from(gallery.querySelectorAll('[data-lcs-editorial-item]'));
      const dialog = document.getElementById(gallery.dataset.lcsGalleryDialogId);
      if (!items.length || !dialog) return;
      let index = 0;

      function setIndex(nextIndex) {
        index = (nextIndex + items.length) % items.length;
        const item = items[index];
        const image = dialog.querySelector('[data-lcs-gallery-image]');
        const caption = item.dataset.caption || `Gallery ${index + 1}`;
        if (image) {
          image.src = item.dataset.src;
          image.alt = item.getAttribute('aria-label')?.replace(/^放大/, '').trim() || caption;
        }
        dialog.querySelectorAll('[data-lcs-gallery-caption]').forEach((node) => { node.textContent = caption; });
      }

      items.forEach((item, itemIndex) => {
        item.addEventListener('click', () => {
          index = itemIndex;
          setIndex(index);
          returnFocus = item;
          dialog.showModal();
        });
      });
      dialog.querySelector('[data-lcs-gallery-prev]')?.addEventListener('click', () => setIndex(index - 1));
      dialog.querySelector('[data-lcs-gallery-next]')?.addEventListener('click', () => setIndex(index + 1));
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        setIndex(index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      gallery.dataset.lcsEditorialReady = 'true';
    });
  }

  function bindDialogs() {
    if (!dialogEventsBound) {
      document.addEventListener('click', (event) => {
        const collectionLink = event.target.closest('a[href="#CollectionSection"]');
        if (!collectionLink) return;
        const collection = document.getElementById('CollectionSection');
        if (!collection) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (window.location.hash !== '#CollectionSection') window.history.pushState(null, '', '#CollectionSection');
        collection.scrollIntoView({ behavior: 'auto', block: 'start' });
        scheduleCollectionReveal();
      }, true);

      document.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-lcs-dialog-open]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.lcsDialogOpen);
          if (!dialog) return;
          event.preventDefault();
          returnFocus = opener;
          dialog.showModal();
          playDialogMedia(dialog);
          return;
        }
        const closer = event.target.closest('[data-lcs-dialog-close]');
        if (closer) closeDialog(closer.closest('dialog'));
      });
      dialogEventsBound = true;
    }
    document.querySelectorAll('.lcs-g04a-dialog').forEach((dialog) => {
      if (dialog.dataset.lcsDialogBound) return;
      dialog.dataset.lcsDialogBound = 'true';
      dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(dialog); });
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); closeDialog(dialog); });
    });
  }

  function syncAll() {
    syncHeroVideos();
    syncDeferredVideos();
    initializeProductCards();
    initializeJournalCarousels();
    initializeQuickShopSticky();
    initializeLookbooks();
    initializeInterviewSections();
    initializeGenderGateways();
    initializeEditorialGalleries();
    bindDialogs();
    if (window.location.hash === '#CollectionSection') scheduleCollectionReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true }); else syncAll();
  motionQuery.addEventListener?.('change', syncAll);
  mobileQuery.addEventListener?.('change', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  window.addEventListener('hashchange', () => { if (window.location.hash === '#CollectionSection') scheduleCollectionReveal(); });
  window.addEventListener('pageshow', () => { if (window.location.hash === '#CollectionSection') scheduleCollectionReveal(); });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll(rootSelector).forEach((video) => video.pause()); else syncAll();
  });
})();